// @flow

import * as React from 'react';
import classNames from 'classnames';

type Props = {
  children: React.Node,
  title?: string,
  className?: string,
  outline?: boolean,
  caps?: boolean,
  bold?: boolean
};

export default class Badge extends React.PureComponent<Props> {
  render() {
    const { children, className, title } = this.props;

    const badgeClassName = classNames(
      "badge ml1 tabular-numerals",
      (this.props.outline ? 'badge--outline' : 'badge--solid'),
      (this.props.caps && 'caps'),
      (this.props.bold && 'semi-bold'),
      className
    );

    return (
      <span className={badgeClassName} title={title}>{children}</span>
    );
  }
}
